export default __webpack_public_path__ + "static/media/3bet_0001_thumb.6d3ae241.jpg";